<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="deleteAcademiaPasarelaPago"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionBillingPaymentMethodsModalDelete.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p>
          {{ $t('mEditionBillingPaymentMethodsModalDelete.messageDelete.element') }}
          <b>{{ $modal.element.asunto }}</b>
          {{ $t('mEditionBillingPaymentMethodsModalDelete.messageDelete.options') }}
        </p>
        <small class="text-color-danger">
            {{ $t('mFeedAssetsContentModalDelete.messageDelete.notReversed') }}
        </small>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonTheModalCancelAction :cancel-text="$t('mEditionBillingPaymentMethodsModalDelete.buttonCancel')"/>
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingPaymentMethodsModalDelete',

  data () {
    return {
      academiaId: '',

      buttonPrimary: {
        action: this.$t('mEditionBillingPaymentMethodsModalDelete.buttonPrimary'),
        behavior: 'delete',
        class: 'a-button-danger-primary',
        sending: false,
        type: 'submit'
      }
    }
  },

  created () {
    this.academiaId = this.$store.getters.getAcademyData.id
  },

  methods: {
    deleteAcademiaPasarelaPago () {
      if (!this.buttonPrimary.sending) {
        this.buttonPrimary.sending = true
        this.$services.delete('academia', 'deleteAcademiaPasarelaPago', {}, [this.academiaId, this.$modal.element])
          .then(response => {
            this.$modal.updateData()
            this.$modal.closeModal()
            this.$alerts.pushAlert('mEditionBillingPaymentMethodsModalDelete', 'deleteAcademiaPasarelaPago', 'success')
            this.buttonPrimary.sending = false
          })
          .catch(error => {
            if (error.response.data.error.message === 'La pasarela de pago esta activa en un producto') {
              this.$modal.showModal('MoleculeEditionBillingPaymentMethodsModalDeleteWarning')
            } else if (error.response.data.error.message === 'Existe una venta con esta pasarela de pago') {
              this.$alerts.pushAlert('mEditionBillingPaymentMethodsModalDelete', 'deleteAcademiaPasarelaPago', 'errorVenta', 'a-alert-danger')
            } else {
              this.$alerts.pushAlert('mEditionBillingPaymentMethodsModalDelete', 'deleteAcademiaPasarelaPago', 'error', 'a-alert-danger')
            }
            this.buttonPrimary.sending = false
          })
      }
    }
  }
}
</script>
